import Vue from 'vue'
import Router from 'vue-router'
import cookie from '@/common/utils/cookie'
import {
  getServiceLocationInfo,
  setFadeOutBody,
  setServiceLocationInfo,
} from '@/common/utils/common'
import _ from 'lodash'
import { getServiceLocation } from '@/common/utils/request'
import memberRoutes from '@/router/memberRoutes'
import adultRoutes from '@/router/adultRoutes'
import otherRoutes from '@/router/otherRoutes'
import errorRoutes from '@/router/errorRoutes'
import settingRoutes from '@/router/settingRoutes'
import categoryRoutes from '@/router/categoryRoutes'
import gnbRoutes from '@/router/gnbRoutes'
import myRoutes from '@/router/myRoutes'
import listRoutes from '@/router/listRoutes'
import customerRoutes from '@/router/customerRoutes'
import voucherRoutes from '@/router/voucherRoutes'
import playerRoutes from '@/router/playerRoutes'
import accountRoutes from '@/router/accountRoutes'
import searchRoutes from '@/router/searchRoutes'
import redirectRoutes from '@/router/redirectRoutes'
import otherInTheMainLayoutRoutes from '@/router/otherInTheMainLayoutRoutes'
import conferenceRoutes from '@/router/conferenceRoutes'
import astroRoutes from '@/router/astroRoutes'
import promotionRoute from '@/router/promotionRoute'
import companyCustomerRoutes from '@/router/companyCustomerRoutes'
import termsRoutes from '@/router/termsRoutes'
import streamRoutes from '@/router/streamRoutes'
import homeRoutes from '@/router/homeRoutes'
import { PATH_NAME_PLAYER_STREAM } from '@/common/resources/router.const'

if (!process || process.env.NODE_ENV !== 'test') {
  Vue.use(Router)
}

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      components: {
        mainLayout: () => import('@/pages/section/MainLayout'),
      },
      children: [
        // app-header, app-footer Om
        ...homeRoutes,
        ...categoryRoutes,
        ...gnbRoutes,
        ...myRoutes,
        ...listRoutes,
        ...customerRoutes,
        ...voucherRoutes,
        ...playerRoutes,
        ...accountRoutes,
        ...searchRoutes,
        ...promotionRoute,
        ...redirectRoutes,
        ...otherInTheMainLayoutRoutes,
        // ...baseballRoutes,
      ],
    },
    ...conferenceRoutes,
    ...astroRoutes,
    // app-header, app-footer X
    ...memberRoutes,
    ...adultRoutes,
    ...settingRoutes,
    ...otherRoutes,
    ...companyCustomerRoutes,
    ...termsRoutes,
    ...errorRoutes,
    ...streamRoutes,
  ],
})

router.beforeEach(async (to, from, next) => {
  const isService = _.get(getServiceLocationInfo(), 'isservice', 'y') === 'y'
  if (to.name === 'waitingService') {
    next()
  } else if (!isService) {
    next('/waiting/service')
  } else {
    if (to.name === PATH_NAME_PLAYER_STREAM) {
      await setFadeOutBody()
    }
    // INFO: AZURE 이관 관련하여 방어 코드 자동로그인을 했으나 브라우저를 종료하여 sessionStorage 의 값이 없는 경우를 산성
    const locationInfo = getServiceLocationInfo()
    const credential = cookie.getCredential()
    if (locationInfo === null && credential !== 'none') {
      getServiceLocation(credential).then((serviceLocation) => {
        const locationInfo = _.get(serviceLocation, ['data'], false)
        if (locationInfo) {
          setServiceLocationInfo(locationInfo)
          next()
        }
      })
    } else {
      next()
    }
  }
})
export default router
